module.exports = __webpack_public_path__ + "img/06.af1a84f8.png";